  <div class="row mt-3">
    <div class="col-sm-12">
      <div class="row" *ngIf="!(isMobile | async)">
        <ng-container *ngFor="let step of stepper">
          <div class="col-sm-4 d-flex justify-content-center">
            <div class="step-div border rounded-circle" [ngClass]="step.status">
              <li class="nav-item letter-div">
                <a class="stepLetter" role="button">
                  {{ step.id }}
                </a>
              </li>
            </div>
            <div class="stepper-text">
              {{ step.name }}
            </div>
          </div>
        </ng-container>
      </div>

      <div class="row d-flex justify-content-center" *ngIf="(isMobile | async)">
        <ng-container *ngFor="let step of stepper">
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-3 w-25">
                <div class="step-div border rounded-circle" [ngClass]="step.status">
                  <li class="nav-item letter-div">
                    <a class="stepLetter" role="button">
                      {{ step.id }}
                    </a>
                  </li>
                </div>
              </div>
              <div class="col-sm-9 w-75">
                <div class="stepper-text">
                  {{ step.name }}
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <ng-container *ngIf="activeStep == 1">
        <div class="row justify-content-center" *ngIf="(newCustomerCompanyError$ | async)">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'error'" [message]="'Could not create Company'"></tan-alert-message>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="container custom-section">
              <form class="mt-3" [formGroup]="companyForm">

                <div class="form-group">
                  <label class="control-label" for="name">Name</label>
                  <input type="text" class="form-control" formControlName="name" />
                  <span class="error"
                    *ngIf="companyForm.get('name').touched && companyForm.get('name').errors?.required">
                    Company name is required</span>
                  <span class="error"
                    *ngIf="companyForm.get('name').touched && companyForm.get('name').errors?.maxlength">
                    Company name cannot be more than 255 characters</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="description">Description</label>
                  <textarea type="text" class="form-control" formControlName="description" rows="3"></textarea>
                </div>

                <div class="form-group">
                  <label class="control-label" for="contact_person">Contact person</label>
                  <input type="text" class="form-control" formControlName="contact_person" />
                  <span class="error"
                    *ngIf="companyForm.get('contact_person').touched && companyForm.get('contact_person').errors?.required">
                    Contact person is required</span>
                  <span class="error"
                    *ngIf="companyForm.get('contact_person').touched && companyForm.get('contact_person').errors?.maxlength">
                    Contact person cannot be more than 50 characters</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="email">Email</label>
                  <input type="email" class="form-control" formControlName="email" />
                  <span class="error"
                    *ngIf="companyForm.get('email').touched && companyForm.get('email').errors?.email">Email
                    is invalid</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="contact_number">Contact number</label>
                  <input type="text" class="form-control" formControlName="contact_number" />
                  <span class="error"
                    *ngIf="companyForm.get('contact_number').errors?.required && companyForm.get('contact_number').touched">
                    Contact number is required<br></span>
                  <span class="error"
                    *ngIf="companyForm.get('contact_number').touched && companyForm.get('contact_number').errors">
                    Number must be between 9 and 15 characters, and only contain numeric values</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="cell_number">Cell number</label>
                  <input type="text" class="form-control" formControlName="cell_number" />
                  <span class="error"
                    *ngIf="companyForm.get('cell_number').touched && companyForm.get('cell_number').errors">
                    Number must be between 9 and 15 characters, and only contain numeric values</span>
                </div>

              </form>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="companyForm.valid">
          <div class="col-sm-12">
            <div class="container custom-section pt-2 pb-2 ar">
              <button type="button" class="btn btn-primary" (click)="saveCompany()">
                <span *ngIf="!(newCustomerCompanyLoading$ | async)">Next</span>
                <span *ngIf="(newCustomerCompanyLoading$ | async)"><i class="fa fa-spinner fa-spin"></i>Saving
                  Company</span>
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="activeStep == 2">
        <div class="row justify-content-center" *ngIf="(newCustomerAddressError$ | async)">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'error'" [message]="'Could not create Address'"></tan-alert-message>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="container custom-section">
              <form class="mt-3" [formGroup]="addressForm">

                <div class="form-group">
                  <label class="control-label" for="address_line1">Address line 1</label>
                  <input type="text" class="form-control" formControlName="address_line1" />
                  <span class="error"
                    *ngIf="addressForm.get('address_line1').touched && addressForm.get('address_line1').errors?.required">
                    Address line 1 is required</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="address_line2">Address line 2</label>
                  <input type="text" class="form-control" formControlName="address_line2" />
                  <span class="error"
                    *ngIf="addressForm.get('address_line2').touched && addressForm.get('address_line2').errors?.required">
                    Address line 2 is required</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="suburb">Suburb</label>
                  <input type="text" class="form-control" formControlName="suburb" />
                  <span class="error"
                    *ngIf="addressForm.get('suburb').touched && addressForm.get('suburb').errors?.required">
                    Suburb is required</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="province">Province</label>
                  <select class="form-control" formControlName="province" id="province" (change)="setProvince()">
                    <option [ngValue]="null">Please select</option>
                    <option *ngFor="let province of provinces" [ngValue]="province.id">{{ province.name }}</option>
                  </select>
                  <span class="error"
                    *ngIf="addressForm.get('province').touched && addressForm.get('province').errors?.required">
                    Province is required</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="postcode">Postal code</label>
                  <input type="text" class="form-control" formControlName="postcode" />
                  <span class="error"
                    *ngIf="addressForm.get('postcode').touched && addressForm.get('postcode').errors?.required">
                    Postal code is required</span>
                </div>

              </form>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="addressForm.valid">
          <div class="col-sm-12">
            <div class="container custom-section pt-2 pb-2 ar">
              <button type="button" class="btn btn-primary" (click)="saveAddress()">
                <span *ngIf="!(newCustomerAddressLoading$ | async)">Next</span>
                <span *ngIf="(newCustomerAddressLoading$ | async)"><i class="fa fa-spinner fa-spin"></i>Saving
                  Address</span>
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="activeStep == 3">
        <div class="row justify-content-center" *ngIf="(newCustomerError$ | async)">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'error'" [message]="'Could not create Customer'"></tan-alert-message>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="container custom-section">
              <form class="mt-3" [formGroup]="customerForm">

                <div class="form-group">
                  <label class="control-label" for="first_name">First name</label>
                  <input type="text" class="form-control" formControlName="first_name" />
                  <span class="error"
                    *ngIf="customerForm.get('first_name').touched && customerForm.get('first_name').errors?.required">
                    First name is required</span>
                  <span class="error"
                    *ngIf="customerForm.get('first_name').touched && customerForm.get('first_name').errors?.maxlength">
                    First name cannot be more than 50 characters</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="last_name">Last name</label>
                  <input type="text" class="form-control" formControlName="last_name" />
                  <span class="error"
                    *ngIf="customerForm.get('last_name').touched && customerForm.get('last_name').errors?.required">
                    Last name is required</span>
                  <span class="error"
                    *ngIf="customerForm.get('last_name').touched && customerForm.get('last_name').errors?.maxlength">
                    Last name cannot be more than 50 characters</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="email">Email</label>
                  <input type="email" class="form-control" formControlName="email" />
                  <span class="error"
                    *ngIf="customerForm.get('email').touched && customerForm.get('email').errors?.email">Email
                    is invalid</span>
                </div>

              </form>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="customerForm.valid">
          <div class="col-sm-12">
            <div class="container custom-section pt-2 pb-2 ar">
              <button type="button" class="btn btn-primary" (click)="saveCustomer()">
                <span *ngIf="!(newCustomerLoading$ | async)">Save</span>
                <span *ngIf="(newCustomerLoading$ | async)"><i class="fa fa-spinner fa-spin"></i>Saving</span>
              </button>
            </div>
          </div>
        </div>
      </ng-container>

    </div>
  </div>